<template>
    <b-card
            bg-variant="light"
            text-variant="black"
            class="buildingContainer"
    >
        <div class="overflow px-2">
            <ShiftImages
                    v-for="(shift, $index) in shifts"
                    :data="shift"
                    :all-shifts="shifts"
                    :shift-index="$index"
                    :shifts-completed="shiftsCompleted"
                    :load-more-shifts="loadMoreShifts"
                    :key="getShiftKey(shift, $index)"
                    class="my-1"
            />
            <b-alert v-if="loadError" show variant="danger" role="alert">
                {{ loadError }}
                <b-button size="sm" variant="outline-danger" :disabled="Boolean(shiftsLoadingPromise)" @click="retryLoad">Повторить</b-button>
            </b-alert>
            <infinite-loading :identifier="infiniteId" @infinite="infiniteHandler">
                <template #no-results><span></span></template>
                <template #no-more><span></span></template>
                <template #error><span></span></template>
            </infinite-loading>
        </div>
    </b-card>
</template>
<script>
    import axios from 'axios';
    import ShiftImages from "./ShiftImages/ShiftImages";
    import InfiniteLoading from 'vue-infinite-loading';

    export default {
        name: "ObjectImages",
        data() {
            return {
                shifts: [],
                skip: 0,
                shiftsCompleted: false,
                shiftsLoadingPromise: null,
                requestGeneration: 0,
                loadError: '',
                infiniteId: 0
            }
        },
        components: {
            ShiftImages,
            InfiniteLoading
        },
        props: {
            workFilters: {type: Object, default: () => ({workIds: [], groupIds: []})},
            data: {
                type: Object,
                required: true
            },
            query: {
                type: String,
                default: null
            },
            reportStatus: {
                type: String,
                default: `all`
            }
        },
        computed: {
            buildingProcessId() {
                return this.data && this.data.building ? this.data.building.processId : null;
            },
            initialShifts() {
                return this.data && Array.isArray(this.data.shifts) ? this.data.shifts : [];
            },
            shiftLimit() {
                return this.isMobileViewport() ? 3 : 5;
            },
            mediaLimit() {
                return this.isMobileViewport() ? 60 : 100;
            }
        },
        mounted() {
            this.resetShifts();
        },
        beforeDestroy() {
            this.requestGeneration++;
            if (this._galleryRequest) this._galleryRequest.cancel();
        },
        methods: {
            isMobileViewport() {
                return typeof window !== 'undefined' && window.innerWidth < 768;
            },
            getShiftKey(shift, index) {
                return shift && (shift.shiftId || shift.shift_id) ? (shift.shiftId || shift.shift_id) : index;
            },
            resetShifts() {
                this.shifts = this.initialShifts.slice();
                this.skip = this.shifts.length;
                this.shiftsCompleted = false;
            },
            buildLoadParams() {
                return {
                    id: this.buildingProcessId,
                    limit: this.shiftLimit,
                    skip: this.skip,
                    query_building: this.query,
                    media_limit: this.mediaLimit,
                    report_status: this.reportStatus,
                    work_ids: this.workFilters.workIds.join(',') || undefined,
                    work_group_ids: this.workFilters.groupIds.join(',') || undefined
                };
            },
            appendShifts(items) {
                items.forEach(item => {
                    this.shifts.push(item);
                });
                this.skip += items.length;
            },
            async loadMoreShifts() {
                if (this.shiftsCompleted) {
                    return [];
                }
                if (!this.buildingProcessId) {
                    this.shiftsCompleted = true;
                    return [];
                }
                if (this.shiftsLoadingPromise) {
                    return this.shiftsLoadingPromise;
                }

                const generation = this.requestGeneration;
                const request = axios.CancelToken.source();
                this._galleryRequest = request;
                this.loadError = '';
                this.shiftsLoadingPromise = this.$store
                    .dispatch(`getImagesForBuilding`, {...this.buildLoadParams(), cancelToken: request.token})
                    .then(data => {
                        if (generation !== this.requestGeneration) return [];
                        if (!Array.isArray(data)) throw new Error('Не удалось загрузить смены');
                        const list = data;
                        if (list.length) {
                            this.appendShifts(list);
                        } else {
                            this.shiftsCompleted = true;
                        }

                        return list;
                    })
                    .catch(err => {
                        if (generation === this.requestGeneration) this.loadError = 'Не удалось загрузить смены. Попробуйте ещё раз.';
                        throw err;
                    })
                    .finally(() => {
                        if (generation === this.requestGeneration) this.shiftsLoadingPromise = null;
                    });

                return this.shiftsLoadingPromise;
            },
            async infiniteHandler($state) {
                const generation = this.requestGeneration;
                try {
                    const data = await this.loadMoreShifts();
                    if (generation !== this.requestGeneration) return;
                    if (data.length && $state) {
                        $state.loaded();
                    } else if ($state) {
                        $state.complete();
                    }
                } catch (err) {
                    if (generation === this.requestGeneration && $state) $state.error();
                }
            },
            retryLoad() {
                this.loadError = '';
                this.infiniteId++;
            }
        }
    }
</script>

<style scoped>
    .buildingContainer {
        margin-bottom: 15px;
        position: relative;
        direction: ltr;
    }
    .overflow::-webkit-scrollbar {
        width: 12px;
    }

    .overflow::-webkit-scrollbar-track {
        background: inherit;        /* color of the tracking area */
    }

    .overflow::-webkit-scrollbar-thumb {
        background-color: #17a2b8;
        border-radius: 20px;
    }
    .overflow {
        max-height: 70vh;
        overflow-y: auto;
        -webkit-overflow-scrolling: touch;
    }

    @media (max-width: 767.98px) {
        .buildingContainer {
            border-radius: 0;
            margin-bottom: 8px;
        }

        .overflow {
            max-height: none;
            overflow: visible;
            padding-left: 6px !important;
            padding-right: 6px !important;
        }
    }
</style>
